<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <h1 class="font-bold text-xl my-1">
        {{ $t("score_pdf.gradebook_of") }}: {{ info.name }}
      </h1>
      <p class="font-medium">
        {{ userInfo.school.name + ": " + userInfo.school.address }}
      </p>
    </div>
    <div class="md-layout-item md-size-50 text-xs my-1">
      <p>
        {{ $t("score_pdf.term_name") }}: {{ info.terms ? info.terms.name : "" }}
      </p>
      <p>{{ $t("score_pdf.primary_teacher") }}: {{ getPrimaryTeacher() }}</p>
    </div>
    <div class="md-layout-item md-size-50 text-xs my-1">
      <p>
        {{ $t("score_pdf.subject") }}:
        {{ info.subject ? info.subject.name : "" }}
      </p>
      <div class="flex">
        <p class="mr-1">{{ $t("score_pdf.secondary_teacher") }}:</p>
        <div>
          <span
            v-for="(teacher, index) in getSecondaryTeacher()"
            :key="'name' + index"
          >
            {{ teacher }} <br />
          </span>
        </div>
      </div>
    </div>
    <div class="md-layout-item md-size-100 mb-6 mt-5">
      <md-table class="table-pdf-assessment">
        <md-table-row class="text-center">
          <md-table-cell>{{ $t("score_pdf.no") }}</md-table-cell>
          <md-table-cell>{{ $t("score_pdf.student_id") }}</md-table-cell>
          <md-table-cell>{{ $t("score_pdf.full_name") }}</md-table-cell>
          <md-table-cell>{{ $t("score_pdf.final_score") }}</md-table-cell>
          <md-table-cell>{{ $t("score_pdf.grade_letter") }}</md-table-cell>
          <md-table-cell>{{ $t("score_pdf.current_score") }}</md-table-cell>
          <md-table-cell
            v-for="(name, index) in headerScore"
            :key="'name' + index"
            >{{
              sisSystem ? name.name : `${name.name}(${name.weight}%)`
            }}</md-table-cell
          >
        </md-table-row>

        <md-table-row
          class="text-center"
          v-for="(row, index) in scorePdf"
          :key="'Score' + index"
        >
          <md-table-cell>{{ index + 1 }}</md-table-cell>
          <md-table-cell>{{ row.student.student_code || "" }}</md-table-cell>
          <md-table-cell>{{ row.student.full_name || "" }}</md-table-cell>
          <md-table-cell>{{ getFinalScore(row) }}</md-table-cell>
          <md-table-cell>{{ getGradeLetter(row) }}</md-table-cell>
          <md-table-cell> {{ getCurrentScore(row) }}</md-table-cell>
          <md-table-cell
            v-for="(category, idx) in getCategoriesScore(index)"
            :key="'category' + idx"
          >
            {{
              sisSystem
                ? category.avg_activity_score.toFixed(2)
                : getScoresLMSSystem(row, category)
            }}/100
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>
<script>
import { TEACHER_ASSIGNMENTS } from "@/constants";
import { mapGetters } from "vuex";

export default {
  name: "export-pdf-score",
  props: ["scorePdf", "info"],
  computed: {
    ...mapGetters("user", { userInfo: "info" }),
    lmsName() {
      return this.info?.lms?.name;
    },
    sisSystem() {
      return this.lmsName === "sis";
    },
    headerScore() {
      if (this.sisSystem) {
        return this.scorePdf[0].categories;
      } else {
        return this.scorePdf[0].class_activity_categories;
      }
    }
  },
  methods: {
    getScoresLMSSystem(row, category) {
      if (category.name === "Scores synced from LMS system") {
        return row.current_score && Number(row.current_score).toFixed(2);
      }
      return category.avg_category && Number(category.avg_category).toFixed(2);
    },
    getCurrentScore(row) {
      if (this.sisSystem || !row.class_activity_categories.length) {
        return row.current_score && Number(row.current_score).toFixed(2);
      }
      return (
        row.current_score_coursework &&
        Number(row.current_score_coursework).toFixed(2)
      );
    },
    getGradeLetter(row) {
      if (this.sisSystem || !row.class_activity_categories.length) {
        return row.grade_letter;
      }
      return row.grade_letter_coursework;
    },
    getFinalScore(row) {
      if (this.sisSystem || !row.class_activity_categories.length) {
        return row.final_score && Number(row.final_score).toFixed(2);
      }
      return (
        row.final_score_coursework &&
        Number(row.final_score_coursework).toFixed(2)
      );
    },
    getCategoriesScore(index) {
      if (this.sisSystem) {
        return this.scorePdf[index]?.categories;
      } else {
        return this.scorePdf[index]?.class_activity_categories;
      }
    },
    getPrimaryTeacher() {
      const primaryTeacher = this.info?.teachers?.find(
        item => item.assignment === TEACHER_ASSIGNMENTS.PRIMARY
      );
      if (!primaryTeacher) return "";
      return primaryTeacher.users?.user_no_sql?.full_name;
    },
    getSecondaryTeacher() {
      const secondaryTeachers = this.info.teachers.filter(
        item => item.assignment === TEACHER_ASSIGNMENTS.SECONDARY
      );
      return secondaryTeachers.map(item => item.users?.user_no_sql?.full_name);
    }
  }
};
</script>
